import { TagType } from '@/ui/components/Tag';
import { ApprovalStatus } from '@/entities/approvals/constants';

export const useApproval = () => {
  const approvalStatusToTagType: { [key in ApprovalStatus]: TagType } = {
    [ApprovalStatus.Pending]: 'primary',
    [ApprovalStatus.ChangesRequested]: 'warning',
    [ApprovalStatus.Approved]: 'success',
    [ApprovalStatus.Rejected]: 'error',
  };

  return {
    approvalStatusToTagType,
  };
};
